import React, { Component } from 'react';
import MapGL, { GeolocateControl, Marker } from 'react-map-gl';
import { Button, ButtonGroup, NavLink } from 'reactstrap';
import { FaDog } from 'react-icons/fa';
import { ArcaLink } from '../Fields/ArcaLink';

const MAPBOX_TOKEN = 'pk.eyJ1IjoibWFya2pyZWdhbiIsImEiOiJjazZwYnYydzMwOWVuM2ttdjZvajJkZXJyIn0.Rv7NtZUnepbhYZ9Gglk5SQ';

export class MapPanel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showMap: false,
            markerLat: 51.45523,
            markerLong: -2.59665,
            viewport: {
                latitude: 51.45523,
                longitude: -2.59665,
                zoom: 14,
                bearing: 0,
                pitch: 0
            }
        };
    }

    componentDidMount() {
        this.props.postcode && this.props.postcode.length > 3 &&
            this.getPostcodes(this.props.postcode);
    }

    async getPostcodes(postcode) {
        try {
            var response = await fetch('https://api.postcodes.io/postcodes/' + postcode, {
                method: 'GET'
            });

            switch (response.status) {
                case 200:
                case 304:
                    var data = (await response.json()).result;
                    this.setState({
                        isError: false,
                        markerLat: data.latitude,
                        markerLong: data.longitude,
                        viewport: {
                            latitude: data.latitude,
                            longitude: data.longitude,
                            zoom: 16
                        },
                        statusText: "Post code lookup succeeded!",
                        showMap: true
                    });

                    break;

                default: {
                    const message = await response.json();

                    this.setState({
                        isError: true,
                        statusText: message
                    });
                    break;
                }
            }
        }
        catch (error) {
            this.setState({
                isError: true,
                statusText: error,
                disabled: false,
                popupOpen: false
            });
        }
    }


    render() {
        var geolocateStyle = {
            float: 'left',
            margin: '15px',
            padding: '10px'
        }

        return (

            <div>
                {this.state.showMap
                    ? <div>
                        <ButtonGroup>
                            <ArcaLink
                                link={'https://www.google.com/maps/dir/?api=1&destination=' + this.state.lat + ',' + this.state.long} target="_blank"
                                text='Directions' />
                        </ButtonGroup>
                        <div />
                        <div >

                            <MapGL
                                {...this.state.viewport}
                                width="100%"
                                height="65vh"
                                mapStyle="mapbox://styles/mapbox/streets-v11"
                                onViewportChange={viewport => this.setState({ viewport })}
                                mapboxApiAccessToken={MAPBOX_TOKEN}>
                                <Marker latitude={this.state.markerLat} longitude={this.state.markerLong}>
                                    <FaDog size='20px' />
                                </Marker>
                                <GeolocateControl
                                    style={geolocateStyle}
                                    positionOptions={{ enableHighAccuracy: true }}
                                    trackUserLocation={true} />
                            </MapGL>

                        </div>
                    </div>
                    : <div>
                        <h4>A full postcode is needed for the map to be show</h4>
                    </div>}
            </div>
        );
    }


}